
import DesignContentLayout from '@/layouts/design/DesignContentLayout';

export default {
  name: 'DesignFoundationsSpacing',
  components: { DesignContentLayout }
};
